import { useQuery } from 'react-query';
import {getVINDetails} from "../api/getVINDetails";

const useVINDetails = (vin,year) => {
  const result = useQuery('vin_details'+year+'_'+vin, () => getVINDetails(vin, null), {
    refetchOnWindowFocus: false
  });
  return result;
};

export default useVINDetails;
